import React from 'react'
import { useDispatch } from 'react-redux'
import { Callout, Button } from "@blueprintjs/core";
import { navigate } from "../../store/navigation/operations";
import { Translate, I18n } from "react-redux-i18n";

 const PrypoolSuccessCheckout=({pool_id})=>{
    const dispatch = useDispatch();

    const goToProducts=()=>{
        dispatch(navigate(`/sharing-box/${pool_id}`));
    }
    return (
        <section className="gray-bg">
        <div className="main-container">
          <div className="prylpool-products-container">
              <Callout title={I18n.t('prypool.transaction_successful')} intent="success" className="payment-callout">    
                <p dangerouslySetInnerHTML={{__html: I18n.t('prypool.success_messages1')}} ></p>
                <p><Translate value="prypool.success_messages2" /></p>
              </Callout>
              <Button role="link" intent="primary" onClick={goToProducts} >
                <Translate value='prypool.back' /> 
              </Button>
          </div>
        </div>
      </section> 
    )
}

export default PrypoolSuccessCheckout;